import React from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall';

/**
 * Component that provides context about PWA installation status
 * Can be used to show different UI based on whether app is installed
 */
const PWAContext = ({ children }) => {
  const { isInstalled } = usePWAInstall();

  // Add a data attribute to body to allow CSS styling based on install state
  React.useEffect(() => {
    if (isInstalled) {
      document.body.setAttribute('data-pwa-installed', 'true');
    } else {
      document.body.removeAttribute('data-pwa-installed');
    }
  }, [isInstalled]);

  return <>{children}</>;
};

export default PWAContext;
